/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const dentalTreatmentTeeth = sqliteTable('dental_treatment_teeth', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  dental_treatment_id: text('dental_treatment_id'),
  patient_id: text('patient_id'),
  tooth: text('tooth'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
